<div class="button-options-wrap">
    <button [routerLink]="['/room',accord.roomId,'start-choices']" class="button-options hvr-float-shadow">Let's
        Discuss</button>
</div>